import React from 'react';
import { Container, Header, Segment, Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Countdown from '../../components/Countdown';
import Timeline2 from '../../components/Timeline2';
import Venue from '../../components/Venue';
import InfoCards from '../../components/InfoCards';
import PetalRain from '../../components/PetalRain';
import WeddingDivider from '../../components/WeddingDivider';
import './styles.css';

const heroImage = `${process.env.PUBLIC_URL}/imgs/hero1.jpg`;

const RingsIcon = () => (
  <img 
    src={`${process.env.PUBLIC_URL}/imgs/timeline/rings.png`} 
    alt="Rings Icon" 
    style={{ width: '40px', height: '40px' }} 
  />
);

const AperitizersIcon = () => (
  <img 
    src={`${process.env.PUBLIC_URL}/imgs/timeline/aperitizer.png`} 
    alt="Aperitizers Icon" 
    style={{ width: '40px', height: '40px' }} 
  />
);

const DrinksIcon = () => (
  <img 
    src={`${process.env.PUBLIC_URL}/imgs/timeline/copas.png`} 
    alt="Drinks Icon" 
    style={{ width: '40px', height: '40px' }} 
  />
);

const FeastIcon = () => (
  <img 
    src={`${process.env.PUBLIC_URL}/imgs/timeline/dinner.png`} 
    alt="Feast Icon" 
    style={{ width: '40px', height: '40px' }} 
  />
);

const DanceIcon = () => (
  <img 
    src={`${process.env.PUBLIC_URL}/imgs/timeline/dance.png`} 
    alt="Dance Icon" 
    style={{ width: '40px', height: '40px' }} 
  />
);

const CakeIcon = () => (
  <img 
    src={`${process.env.PUBLIC_URL}/imgs/timeline/cake.png`} 
    alt="Cake Icon" 
    style={{ width: '40px', height: '40px' }} 
  />
);

function Boda() {
  const { t } = useTranslation();
  
  // Timeline events con iconos SVG
  const timelineEvents = [
    {
      time: '13:00',
      title: t('events.reception.title'),
      icon: <DrinksIcon />
    },
    {
      time: '13:30',
      title: t('events.ceremony.title'),
      icon: <RingsIcon />
    },
    {
      time: '14:30',
      title: t('events.aperitif.title'),
      icon: <AperitizersIcon />
    },
    {
      time: '16:00',
      title: t('events.dinner.title'),
      icon: <FeastIcon />
    },
    {
      time: '18:00',
      title: t('events.cake.title'),
      icon: <CakeIcon />
    },
    {
      time: '19:00',
      title: t('events.party.title'),
      icon: <DanceIcon />
    }
  ];
  
  return (
    <div>
      <PetalRain />
      <Segment
        inverted
        textAlign='center'
        className="boda-hero-segment"
        vertical
      >
        {/* Background image with blur */}
        <div className="boda-hero-background" style={{ backgroundImage: `url(${heroImage})` }} />
        
        {/* Dark overlay */}
        <div className="boda-hero-overlay" />
        
        <Container text className="boda-hero-container">
          <Header
            as='h2'
            content={t('home.wereGettingMarried')}
            inverted
            className="boda-hero-subtitle"
          />
          <Header
            as='h1'
            inverted
            className="boda-hero-title"
          >
            Aurel <span className="boda-hero-title-separator">&</span> Dennys
          </Header>
          
          <div className="boda-wedding-date">
            31 Oct 2026
          </div>
          
          <Countdown />
          
          <Button 
            as={Link} 
            to='/rsvp' 
            inverted
            basic
            size='massive'
            className="boda-hero-button"
          >
            {t('home.confirmButton')}
          </Button>
          <p className="boda-hero-deadline">{t('home.deadline')}</p>
        </Container>
      </Segment>

      {/* Timeline Section */}
      <Segment vertical className="boda-timeline-section">
        <Container>
          <p className="narrative-intro">{t('events.timelineIntro')}</p>
          <Timeline2 events={timelineEvents} />
        </Container>
      </Segment>

      <WeddingDivider />

      {/* Venue Section */}
      <Venue />

      <WeddingDivider />

      {/* Info Cards Section */}
      <InfoCards />
    </div>
  );
}

export default Boda;
